import * as Yup from 'yup'
import { POS_TYPES } from '../../../../../../../gateways/breadstack/posConnectionApis'

export interface PosStepFormValues {
  provider: string
  covaCompanyId: string
  covaClientId: string
  covaClientSecret: string
  covaUsername: string
  covaPassword: string
  greenlineCompanyId: string
  posGreenlineUsingTaxV2: boolean
  posLocationId: string
}

export const EMPTY_POS_STEP_VALUES: PosStepFormValues = {
  provider: '',
  covaCompanyId: '',
  covaClientId: '',
  covaClientSecret: '',
  covaUsername: '',
  covaPassword: '',
  greenlineCompanyId: '',
  posGreenlineUsingTaxV2: false,
  posLocationId: '',
}

const numericId = (label: string) =>
  Yup.string()
    .trim()
    .required(`Please enter the ${label}`)
    .matches(/^\d+$/, `${label} must be numeric`)

const requiredFor = (provider: string, schema: Yup.StringSchema) =>
  Yup.string().when('provider', {
    is: provider,
    then: () => schema,
    otherwise: (s) => s.notRequired(),
  })

// Phase A — store not POS-linked yet: provider + its credentials.
export const connectSchema = Yup.object({
  provider: Yup.string().required('Select a POS provider'),
  covaCompanyId: requiredFor(POS_TYPES.COVA, numericId('Company ID')),
  covaClientId: requiredFor(
    POS_TYPES.COVA,
    Yup.string().trim().required('Please enter the Client ID'),
  ),
  covaClientSecret: requiredFor(
    POS_TYPES.COVA,
    Yup.string().trim().required('Please enter the Client Secret'),
  ),
  covaUsername: requiredFor(
    POS_TYPES.COVA,
    Yup.string().trim().required('Please enter the username'),
  ),
  covaPassword: requiredFor(
    POS_TYPES.COVA,
    Yup.string().required('Please enter the password'),
  ),
  greenlineCompanyId: requiredFor(POS_TYPES.GREENLINE, numericId('Company ID')),
})

// Phase B — store linked: a POS location must be picked (or the step skipped).
export const selectLocationSchema = Yup.object({
  posLocationId: Yup.string().required('Select a POS location'),
})

export const addCompanySchema = numericId('Greenline Company ID')
